export default __webpack_public_path__ + "static/media/mon_24.b706144c.png";